<template>
  <v-footer dark absolute app :color="isManagementURL() ? `managementNavbar lighten-2` : `navbar lighten-2`">
    <v-card class="flex" flat tile :color="isManagementURL() ? `managementNavbar lighten-2` : `navbar lighten-2`">
      <v-card-text class="py-2 white--text text-center">
        &copy; {{ new Date().getFullYear() }}
        <strong>
          CiTIUS — Centro Singular de Investigación en Tecnoloxías Intelixentes da USC
        </strong>
          · Version {{ version }}
          · Compilation {{ compilationdate() }}
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
  import { version } from '../../../package.json'
  import { compilationdate } from '../../App.vue'
export default {
data:  () => ({
  version: version,
  compilationdate: compilationdate
}),
methods: {
  isManagementURL() {
    if(this.$route.path.includes("manage/") || this.$route.path.includes("direction/") ) return true;
    else return false;
  },
},
mounted(){
  var elem = document.createElement('script');
  elem.src = "/bottomicon-citius/bottomicon-citius.js";
  document.body.appendChild(elem);
}
};
</script>

<style scoped></style>
